// import components
import { Box, styled } from '@mui/material';

export const StyledPlanUnitDetailsBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'flex',
  gap: theme.spacing(4),
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(6)
}));
